import script from "./SecSectionHeading.vue?vue&type=script&setup=true&lang=js"
export * from "./SecSectionHeading.vue?vue&type=script&setup=true&lang=js"

import "./SecSectionHeading.vue?vue&type=style&index=0&id=a206b09a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a206b09a"]])

export default __exports__